import { render, staticRenderFns } from "./QrCodeReader.vue?vue&type=template&id=0f1dce84&scoped=true"
import script from "./QrCodeReader.vue?vue&type=script&lang=js"
export * from "./QrCodeReader.vue?vue&type=script&lang=js"
import style0 from "./QrCodeReader.vue?vue&type=style&index=0&id=0f1dce84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1dce84",
  null
  
)

export default component.exports